export const notificationsRootPath = '/notifications';
